<template>
  <div class="page-container">
    <h1 class="page-title">{{ t('pages.company.structure.tech.title') }}</h1>
    <div class="content">
      <!-- 第一段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.structure.tech.content').split('---')[0]"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped lang="scss">
/* 页面特定样式可以放在这里 */
</style> 